export default () => {
  if (!localStorage.getItem('cookie:accepted')) {
    return;
  }

  if (localStorage.getItem('cookie:accepted') !== 'true') {
    return;
  }

  let a = document.createElement("script");
  let c = document.getElementsByTagName("script")[0];
  a.async = !0;
  a.src = 'https://cdn.masslytics.io/masslytics.js';
  c.parentNode.insertBefore(a,c);
  window.masslyticsApiSubdomain="app";
  window.masslyticsBrandId="SW-836005";
};
